export class ChangePasswordInfo {
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

export class PasswordValidationInfo {
  public minLength: boolean = false;
  public maxLength: boolean = false;
  public lower: boolean = false;
  public upper: boolean = false;
  public digit: boolean = false;
  public symbol: boolean = false;

  public isValid(): boolean {
    const attrs = Object.keys(this);
    return attrs.every((_) => this[_] === false);
  }
}
